import { Dialog } from '@ordr-as/umami-react/dialog';
import { TextInput } from '@ordr-as/umami-react/form';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import type { OrderLineDto } from '../../../../../../../generated-api/models/OrderLineDto';
import { getUniqueOrderLineKey } from '../../../../../../utils/orderLineUtils';
import { useCartStore } from '../../../../../../context/cart/CartStore';

interface CartItemCommentDialogProps {
  onClose: () => void;
  orderLine: OrderLineDto;
}

function CartItemCommentDialog({ ...props }: CartItemCommentDialogProps) {
  const { onClose, orderLine } = props;
  const setOrderLineComment = useCartStore((x) => x.setOrderLineComment);
  const intl = useIntl();

  const [comment, setComment] = useState<string | undefined>(orderLine.comment ?? '');

  const handleSaveCommentToCartItem = () => {
    const orderLineKey = getUniqueOrderLineKey(orderLine);
    setOrderLineComment(orderLineKey, comment);

    onClose();
  };

  const handleOnDataChange = (value: string) => {
    setComment(value);
  };

  return (
    <Dialog
      className="w-full mx-4 tablet:w-1/2 tablet:mx-0"
      onClose={onClose}
      title={intl.formatMessage({ id: `checkout.note.header` })}
      onAction={handleSaveCommentToCartItem}
      actionLabel={intl.formatMessage({ id: 'generic.save' })}
      alignTop
    >
      <TextInput
        autoFocus
        onChange={handleOnDataChange}
        value={comment}
        multiline
        maxLength={140}
        label={intl.formatMessage({ id: `checkout.note.description` })}
        fullWidth
      />
    </Dialog>
  );
}

export default CartItemCommentDialog;
